<template>
  <div class="container py-3 px-3 py-md-5 px-md-5">
    <page-header header="Profile" subText="Create the best profile for your applications with the same info on your passport."></page-header>
    <div class="d-flex py-3 py-md-0 mt-2 mb-4 mb-md-5 tabButtons" :style="cssProps">
      <router-link :to="{name: 'AccountInfo'}">Account Info</router-link>
      <router-link :to="{name: 'PersonalInfo'}">Personal Info</router-link>
      <router-link :to="{name: 'EducationalHistory'}">Educational History</router-link>
      <router-link :to="{name: 'ExamScoresHistory'}">Exam Scores</router-link>
      <router-link :to="{name: 'BackgroundInfoHistory'}">Background Info</router-link>
      <router-link :to="{name: 'DocumentList'}">Documents</router-link>
    </div>
    <router-view ref="childComp"/>
  </div>
</template>
<script>
import PageHeader from '@/components/PageHeader.vue'
import { Colors } from '@/utils/constants'

export default {
  name: 'StudentProfile',
  components: {
    PageHeader
  },
  data: function () {
    return {
      authenticated: true,
      currentTab: 0
    }
  },
  methods: {
    switchTabs (val) {
      this.currentTab = val
    }
  },
  computed: {
    cssProps () {
      return {
        '--primary-color': Colors.primaryColor,
        'overflow-x': 'auto'
      }
    },
    currentUser () {
      return this.$store.state.user.currentUser
    },
    currentTabComp () {
      if (this.currentTab === 0) {
        return 'personal-info'
      } else if (this.currentTab === 1) {
        return 'education-history'
      } else if (this.currentTab === 2) {
        return 'exam-scores-history'
      } else if (this.currentTab === 3) {
        return 'background-info-history'
      } else if (this.currentTab === 4) {
        return 'document-list'
      } else {
        return 'personal-info'
      }
    }
  },
  mounted () {
    if (this.currentUser == null) {
      this.$router.push('/students/login')
    }
  }
}
</script>
<style scoped>
  .tabButtons a{
    text-decoration: none;
    margin-right: 50px;
    font-weight: 500;
    color: gray;
  }

  .tabButtons a.router-link-exact-active{
    color: var(--primary-color);
  }
</style>
